import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=c4439e64&scoped=true"
import script from "./SearchIndex.vue?vue&type=script&lang=js"
export * from "./SearchIndex.vue?vue&type=script&lang=js"
import style0 from "./SearchIndex.vue?vue&type=style&index=0&id=c4439e64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4439e64",
  null
  
)

export default component.exports